import { TileGridVariant } from 'components/TileGrid/TileGridVariant';
import { FilestackImageFit, FilestackImageQuality } from 'types/Filestack';

type TileGridTileImagePropsBySize = {
  width: number;
  height: number;
  fit: FilestackImageFit;
  quality: FilestackImageQuality;
  borderRadius?: number;
  qaId: string;
  marginBottom: number;
  oneByOneRatio?: boolean;
};

export const tileGridTilePropsByVariant: Record<
  TileGridVariant,
  TileGridTileImagePropsBySize
> = {
  SMALL: {
    width: 238,
    height: 80,
    fit: 'max',
    quality: 'high',
    qaId: 'small-image',
    marginBottom: 24,
  },
  LARGE: {
    width: 238,
    height: 238,
    fit: 'crop',
    quality: 'medium',
    borderRadius: 999,
    qaId: 'large-image',
    marginBottom: 36,
    oneByOneRatio: true,
  },
  LARGE_RECTANGULAR: {
    width: 238,
    height: 238,
    fit: 'crop',
    quality: 'medium',
    borderRadius: 8,
    qaId: 'large-rectangular-image',
    marginBottom: 36,
    oneByOneRatio: true,
  },
};
